import postRequest from '@helpers/api/post';

import { submissionsConfig } from './helpers';

/**
 * Creates DE Submission
 * @param {Object} [$0={}] - payload
 * @param {string} $0.id - unique identifier
 * @param {string} $0.password - elster password
 * @param {boolean} $0.isEncrypted - is password encrypted?
 * @returns {Promise<unknown | void>}
 */
export const createDESubmission = ({ id, password, isEncrypted } = {}) =>
  postRequest(`vFile/submission/de/${id}/`, {
    password,
    is_encrypted: isEncrypted,
  });

/**
 * Creates GB Submission
 * @param {string} standardTemplate - unique standard template identifier
 * @returns {Promise<unknown | void>}
 */
export const createGbSubmission = standardTemplate =>
  postRequest(`vFile/submission/gb/${standardTemplate}/`, submissionsConfig());
